import { AccessibilityIcon } from "@svg/organization/accessiblity";
import { EducationIcon } from "@svg/organization/education";
import { UnlimitedUserIcon } from "@svg/organization/unlimited-user";

const baseUrl = process.env.NEXT_PUBLIC_API_BASE_URL;

export const organizationServiceItem = [
  {
    icon: AccessibilityIcon,
    withNumber: true,
    title: `دسترسی به بیش از number عنوان آموزش `,
    description:
      "از مهارت‌های سخت فنی تا مهارت‌های نرم مدیریتی و ارتباطی، همه را در یک بستر یکپارچه برای رشد، یادگیری و توانمندسازی سازمان خود فراهم کنید.",
  },
  {
    icon: UnlimitedUserIcon,
    withNumber: false,
    title: "امکان تعریف کاربران نامحدود برای هر سازمان",
    description:
      "به همه‌ی اعضای سازمان خود فرصت دهید تا بدون محدودیت و با یادگیری مستمر و  هدفمند در مسیر رشد و توسعه‌ی جمعی سازمان نقش‌آفرین باشند.",
  },
  {
    icon: EducationIcon,
    withNumber: false,
    title: "سنجش میزان پیشرفت مطالعاتی هر فرد",
    description:
      "با گزارش‌های دقیق و تحلیلی، مسیر یادگیری کارکنان خود را بهتر بشناسید و از رشد مداوم، پیشرفت شخصی و توسعه‌ی سازمانی آن‌ها پشتیبانی کنید.",
  },
];

export const organs = [
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832dff71867-taavon-vezarat.jpeg",
    title: "وزارت تعاون، کار و رفاه اجتماعی",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/mellat.png",
    title: "بانک ملت",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832df6da2b6-tosea-bank.jpeg",
    title: "بانک توسعه تعاون",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832d41e99fb-irid.jpeg",
    title: "شرکت گسترش صنایع ریلی ایران",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/folad.png",
    title: "فولاد مبارکه اصفهان",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832dfb2b3b7-tamin.jpeg",
    title: "سازمان تامین اجتماعی",
  },
  {
    icon: "https://faradars.org/wp-content/uploads/2025/10/29/nezam.png",
    title: "نظام مهندسی ساختمان",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/mokhaberat.jpeg",
    title: "شرکت مخابرات ایران",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/alame.jpeg",
    title: "دانشگاه علامه",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/22/zamyad.png",
    title: "زامیاد",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832d463c4a2-varagh.jpeg",
    title: "شرکت صنایع ورق ایران",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/elmosanat.png",
    title: "دانشگاه علم و صنعت",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/razavi.jpeg",
    title: "سازمان همیاری شهرداری‌های استان خراسان رضوی",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/salman-co.jpeg",
    title: "شرکت کشت‌ و صنعت سلمان فارسی",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/naft.jpeg",
    title: "شرکت واسپاری صنعت نفت آیندگان",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/ptroshimi.png",
    title: "شرکت پتروشیمی مهاباد",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/mobin.jpeg",
    title: "مبین سرمایه",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/parsa.jpeg",
    title: "پردازش الکترونیک راشد سامانه (پارسا)",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/kabir.jpeg",
    title: "شرکت مهندسی راژمان کبیر",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/beheshti.jpeg",
    title: "دانشگاه شهید بهشتی",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/mahtab.jpeg",
    title: "آرین ماهتاب گستر",
  },
  {
    icon: "https://faradars.org/wp-content/uploads/2025/10/29/موسسه-فرهنگی-احسان.png",
    title: "موسسه فرهنگی احسان",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/edalat.jpeg",
    title: "موسسه حقوقی نواندیشان عدالت گستر صبا",
  },
  {
    icon: "https://cdn.faradars.org/wp-content/uploads/2022/11/27/kaprila-vertical-1.png",
    title: "کاپریلا",
  },
];

export const benefitOrganizations = [
  "ارتقای هم‌زمان مهارت‌های نرم و سخت کارکنان",
  "سرمایه‌گذاری روی رشد کارکنان، افزایش رضایت شغلی کارکنان",
  "بهره‌گیری از آموزش برای رسیدن به اهداف کلیدی سازمان",
  "توانمندسازی و توسعه مهارت‌های رهبری مدیران",
  "کاهش خطاهای انسانی با افزایش علمی و مهارتی کارکنان",
];
export const benefitOrganizationsGoal = [
  "آموزش هدفمند، تحقق اهداف سازمان",
  "تامین نیاز به منابع انسانی متخصص با آموزش کارکنان",
  "برنامه‌ریزی آموزشی با اهداف بلند مدت",
  "افزایش بهره‌وری با استفاده از روش‌های بهینه و نوآورانه",
];

export const organisationCommentsData = [
  {
    user: {
      name: "آقای امیررضا پاکزاد",
      image:
        "https://cdn.faradars.org/wp-content/uploads/2022/11/27/alame.jpeg",

      field: "دبیر انجمن علمی مدیریت صنعتی دانشگاه علامه",
    },
    comment: {
      text: "قیمت آموزش‌های فرادرس نسبت به دیگر مراکز آموزشی، حقیقتا پایین است. دسترسی به آموزش‌های فرادرس برای دانشجویان بسیار آسان بود و می‌توانستند با استفاده از کامپیوتر شخصی، لپ‌تاپ یا موبایل خود، در هر زمان که تمایل داشتند، آموزش ببینند. مسئله مهم دیگر این بود که آموزش‌های تهیه شده از فرادرس، پیوستگی و فصل‌بندی خوبی داشتند.",
      stars: 5,
      date: "2025-10-21T00:00:00Z",
    },
  },
  {
    user: {
      name: "خانم مینا خسروی",
      image:
        "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832d463c4a2-varagh.jpeg",
      field: "مسئول دفتر شرکت صنایع ورق ایران",
    },
    comment: {
      text: ` دسترسی به آموزش‌ها در فرادرس بسیار آسان است و ما می‌توانیم در هر زمان
از شبانه‌روز، آموزش‌ها را مشاهده کنیم. توضیحات ارائه شده در آموزش‌ها،
بسیار واضح و روشن است. از دیگر ویژگی‌های مثبت فرادرس، پشتیبانی خوبی
است که دارند. من طی استفاده از طرح آموزش سازمانی، چندین بار با بخش
پشتیبانی در تماس بودم که به خوبی من را راهنمایی کردند و پاسخگو بودند.`,
      stars: 5,
      date: "2023-09-15T00:00:00Z",
    },
  },
  {
    user: {
      name: "آقای محسن غفوری",
      image:
        "https://cdn.faradars.org/wp-content/uploads/2022/11/27/63832d41e99fb-irid.jpeg",
      field: "مدیر انفورماتیک شرکت صنایع ریلی ایران",
    },
    comment: {
      text: "آموزش‌های فرادرس کاربردی هستند و همه توضیحات لازم و کلیدی پیرامون موضوعات آموزش‌ها، در آن‌ها ارائه شده است. وضیحات ارائه شده در آموزش واقعا خوب بود و مطالب به صورت نکته به نکته و با سرفصل‌بندی مناسب ارائه شدند. در کل، آموزش‌های ارائه شده در فرادرس، ساختار خاص و ثابتی را در بحث تدریس دارند و این نظم، به خوبی مشخص است.",
      stars: 5,
      date: "2024-12-25T00:00:00Z",
    },
  },
  {
    user: {
      name: "آقای مصطفی ملکوتی‌زاده",
      image:
        "https://cdn.faradars.org/wp-content/uploads/2022/11/27/edalat.jpeg",

      field: "کارشناس آموزش موسسه حقوقی صبا",
    },
    comment: {
      text: " آموزش‌های فرادرس از جنبه محتوایی بسیار راضی‌کننده هستند. به جای استفاده از ویدئوهای کوتاه و پراکنده که در منابع گوناگون وجود دارند، در فرادرس می‌توان یک دوره آموزشی متمرکز را برای یک موضوع خاص مشاهده کرد. در عین حال، کیفیت تدریس و سهولت دسترسی به آموزش‌ها نیز از دیگر دلایلی هستند که موجب می‌شوند تا فرادرس را به دیگران نیز پیشنهاد کنم.",
      stars: 5,
      date: "2025-06-02T00:00:00Z",
    },
  },
  {
    user: {
      name: "آقای دکتر حسن عاشقی",
      image:
        "https://faradars.org/wp-content/uploads/2025/11/10/بانک-توسعه-تعاون.png",

      field: "رئیس کل آموزش بانک توسعه تعاون",
    },
    comment: {
      text: " برای بحث آموزش، اغلب همکاران، آموزش‌های فرادرس را به من پیشنهاد می‌دادند. بعد از تهیه آموزش‌ها همکاران با رضایت آن‌ها را مشاهده می‌کردند و بازخوردهای مثبتی دریافت کردیم. آموزش‌های  فرادرس کاملا کاربردی و مختصر هستند و مهم‌ترین نکته‌ای که همکاران پیرامون آموزش‌ها به آن‌ها اشاره می‌کردند، همین بحث کاربردی بودن آن‌ها است.",
      stars: 5,
      date: "2025-11-06T00:00:00Z",
    },
  },
];

export const organizationCourseTabsSource = [
  {
    id: "office",
    name: "آفیس",
    title: "office",
    url: `${baseUrl}explore?page=1&limit=9&orderby=sku&sku=fvppt009,fvvso007,fvacs301,fvmng01031,fvwd102,fvppt01012,fvwd004,fvacw9710,fvmop9807`,
    sku: "fvppt009,fvvso007,fvacs301,fvmng01031,fvwd102,fvppt01012,fvwd004,fvacw9710,fvmop9807",
  },
  {
    id: "icdl",
    name: "مهارت های کاربردی کامپیوتر ICDL",
    title: "icdl",
    url: `${baseUrl}explore?page=1&limit=9&orderby=sku&sku=fvasmb9410,fvwin0101,fvpub01033,fvwin009,fvppt009,fvpub0104,fvpub108,fvwd004,fvwin010`,
    sku: "fvasmb9410,fvwin0101,fvpub01033,fvwin009,fvppt009,fvpub0104,fvpub108,fvwd004,fvwin010",
  },
  {
    id: "human-resources",
    name: "مدیریت منابع انسانی",
    title: "human-resources",
    url: `${baseUrl}explore?page=1&limit=6&orderby=sku&sku=fvpub356,fvmng0021,fvmng99062,fvpub346,fvmng303,fvba323`,
    sku: "fvpub356,fvmng0021,fvmng99062,fvpub346,fvmng303,fvba323",
  },
  {
    id: "development",
    name: "توسعه مهارت فردی",
    title: "development",
    url: `${baseUrl}explore?page=1&limit=13&orderby=sku&sku=fvpub110,fvpub362,fvpsy168,fvacw307,fvpsy125,fvmng9704,fvpsy134,fvacw0064,fvpsy128,fveng0103,fvmng0071,fvpsy154,fvpub125`,
    sku: "fvpub110,fvpub362,fvpsy168,fvacw307,fvpsy125,fvmng9704,fvpsy134,fvacw0064,fvpsy128,fveng0103,fvmng0071,fvpsy154,fvpub125",
  },
  {
    id: "information-technology",
    name: "مدیریت فناوری اطلاعات",
    title: "information-technology",
    url: `${baseUrl}explore?page=1&limit=5&orderby=sku&sku=fvmng99112,fvit302,fvbi9906,fvmng131,fvmng330`,
    sku: "fvmng99112,fvit302,fvbi9906,fvmng131,fvmng330",
  },
];
